function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */
import { resetMessage, uploadFile } from '@engine/actions/creators/upload-file';
import Button from '@engine/components/presentational/base/button';
import Error from '@engine/components/presentational/base/error';
import Icon from '@engine/components/presentational/base/icon';
import ProgressBar from './progress-bar';
import React from 'react';
import { connect } from 'react-redux';

var FileUpload = /*#__PURE__*/function (_React$Component) {
  _inherits(FileUpload, _React$Component);

  var _super = _createSuper(FileUpload);

  function FileUpload(props) {
    var _this;

    _classCallCheck(this, FileUpload);

    _this = _super.call(this, props);

    _this.resetInput = function (event) {
      event.target.value = null;

      _this.props.resetMessage(_this.props.inputName);
    };

    _this.changeFile = function (event) {
      _this.setState({
        file: event.target.files[0]
      });
    };

    _this.sendFile = function (event) {
      event.preventDefault();

      if (!_this.state.file.size) {
        return;
      }

      _this.props.uploadFile(_this.props.url, _this.props.inputName, _this.state.file);

      _this.setState(_this.initialState);
    };

    _this.responseStatuses = {
      success: 'success',
      warning: 'warning',
      error: 'danger'
    };
    _this.initialState = {
      file: {
        name: ''
      }
    };
    _this.state = _this.initialState;
    return _this;
  }

  _createClass(FileUpload, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetMessage(this.props.inputName);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          response = _this$props.response,
          showProgress = _this$props.showProgress,
          progress = _this$props.progress;
      return React.createElement("form", {
        className: "form-horizontal",
        id: "upload-file"
      }, React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "col-sm-8"
      }, React.createElement("div", {
        className: "input-group"
      }, React.createElement("div", {
        className: "input-group-btn"
      }, React.createElement("span", {
        className: "btn btn-primary btn-file"
      }, React.createElement(Icon, {
        icon: "upload",
        className: "mr-5"
      }), I18n.t('actions.default.browse'), React.createElement("input", {
        type: "file",
        name: this.props.inputName,
        id: this.props.inputName,
        className: "form-control",
        accept: this.props.accept,
        onChange: this.changeFile,
        onClick: this.resetInput
      }))), React.createElement("input", {
        type: "text",
        value: this.state.file.name,
        className: "form-control",
        readOnly: true
      })), React.createElement("div", {
        className: "input-info-text"
      }, React.createElement(Icon, {
        icon: "info-sign"
      }), "\xA0", this.props.infoText)), React.createElement("div", {
        className: "col-sm-4"
      }, React.createElement(Button, {
        className: "btn btn-success btn-block",
        onClick: this.sendFile
      }, this.props.submitText))), showProgress && React.createElement(ProgressBar, {
        percent: progress
      }), response.errors && React.createElement(Error, null, response.message, React.createElement("ul", null, response.errors.map(function (message) {
        return React.createElement("li", {
          key: message
        }, message);
      }))), response.message && !response.errors && React.createElement("div", {
        className: "alert alert-".concat(this.responseStatuses[response.status] || 'info', "-light")
      }, response.message));
    }
  }]);

  return FileUpload;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    showProgress: state["".concat(props.inputName, "-upload")].showProgress,
    progress: state["".concat(props.inputName, "-upload")].progress,
    response: state["".concat(props.inputName, "-upload")].response
  };
};

export default connect(mapStateToProps, {
  uploadFile: uploadFile,
  resetMessage: resetMessage
})(FileUpload);